var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39307 8.56707C1.39307 7.21 2.50028 6.10278 3.85735 6.10278H21.4288C21.843 6.10278 22.1788 6.43857 22.1788 6.85278C22.1788 7.267 21.843 7.60278 21.4288 7.60278H3.85735C3.32871 7.60278 2.89307 8.03843 2.89307 8.56707V11.5671C2.89307 11.9813 2.55728 12.3171 2.14307 12.3171C1.72885 12.3171 1.39307 11.9813 1.39307 11.5671V8.56707Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6257 1.61652C16.9187 1.32376 17.3936 1.32398 17.6863 1.61701L22.3878 6.32271C22.6804 6.61564 22.6803 7.09033 22.3875 7.38313L17.6861 12.0845C17.3932 12.3774 16.9183 12.3774 16.6254 12.0845C16.3325 11.7917 16.3325 11.3168 16.6254 11.0239L20.7968 6.85256L16.6252 2.67718C16.3324 2.38416 16.3326 1.90928 16.6257 1.61652Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8575 11.6829C22.2717 11.6829 22.6075 12.0186 22.6075 12.4329V15.4329C22.6075 16.7899 21.5003 17.8971 20.1432 17.8971H2.57178C2.15756 17.8971 1.82178 17.5614 1.82178 17.1471C1.82178 16.7329 2.15756 16.3971 2.57178 16.3971H20.1432C20.6719 16.3971 21.1075 15.9615 21.1075 15.4329V12.4329C21.1075 12.0186 21.4433 11.6829 21.8575 11.6829Z",
    fill: "#265EA7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37483 11.9153C7.66772 12.2082 7.66772 12.6831 7.37482 12.976L3.20349 17.1473L7.37507 21.3227C7.66783 21.6157 7.66761 22.0906 7.37458 22.3834C7.08156 22.6761 6.60668 22.6759 6.31392 22.3829L1.6125 17.6772C1.31983 17.3843 1.31994 16.9096 1.61274 16.6168L6.31417 11.9153C6.60706 11.6225 7.08193 11.6225 7.37483 11.9153Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/Exchange.592d6ddc5a0b77678bcae1e5ee1abaac.svg";
export { ForwardRef as ReactComponent };